import React, { useState } from 'react';
import { useBookAudioPlayer } from '../../context/bookAudioPlayerContext';
import AudioPauseIcon from '../../images/svg-gcbooks/audio-pause-icon';
import AudioPlayIcon from '../../images/svg-gcbooks/audio-play-icon';
import ProgressBar from '../../components/ProgressBar';
import UKflag from '../../images/svg-gcbooks/ukflag.png';
import USflag from '../../images/svg-gcbooks/usflag.png';
import AUSflag from '../../images/svg-gcbooks/ausflag.jpg';
import SpeedSelector from './playbackMenu';

export default function BookAudioPlayer() {
  const {
    toggle,
    progressPercent,
    currentTime,
    currentTimeInSeconds,
    audioState,
    totalDurations,
    handleNext,
    handlePrevious,
    rawTotalDuration,
    handleSeek,
    handleClose,
    audioDetails,
    selectedVoice,
    setSelectedVoice,
    handleUpdateVolume,
    volume,
    playbackSpeed,
  } = useBookAudioPlayer();
  const isPlaying = audioState === 'playing';
  const [showVolumeSlider, setShowVolumeSlider] = useState(false);
  const [showPlaybackMenu, setShowPlaybackMenu] = useState(false);
  const [isVoiceDropdownOpen, setIsVoiceDropdownOpen] = useState(false);

  const voices = [
    {
      category: 'Modern',
      name: 'Charlene',
      flag: UKflag,
    },
    {
      category: 'Original',
      name: 'Callie',
      flag: USflag,
    },
    {
      category: 'Dramatized',
      name: 'Nancy',
      flag: AUSflag,
    },
  ];

  const handleSelectVoice = (voice) => {
    setSelectedVoice(voice);
    setIsVoiceDropdownOpen(false);
  };

  const currentVoice = voices.find((v) => v.name === selectedVoice) || voices[0];

  return (
    <div className="book-audio-player">
      <div className="audio-player-control-buttons-container">
        <div className="audio-controls">
          {/* Previous Button */}
          <button className="control-btn previous-btn" onClick={handlePrevious} aria-label="Previous">
            <svg width="11" height="16" viewBox="0 0 11 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.75 0V15.328L3.086 7.664L10.75 0ZM2 0.664V14.664H0V0.664H2Z" fill="#F6F6F7" />
            </svg>
          </button>
          {/* Play/Pause Button */}
          <button className="control-btn play-pause-btn" onClick={() => toggle(audioDetails)}>
            {isPlaying ? <AudioPauseIcon /> : <AudioPlayIcon />}
          </button>
          {/* Next Button */}
          <button className="control-btn next-btn" onClick={handleNext} aria-label="Next">
            <svg width="11" height="16" viewBox="0 0 11 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 0V15.328L7.664 7.664L0 0ZM8.75 0.664V14.664H10.75V0.664H8.75Z" fill="#F6F6F7" />
            </svg>
          </button>
        </div>
        {/* Track Information */}
        <div className="track-info">
          <div className="track-title">The Great Controversy - Chapter {audioDetails.index + 1}</div>
          <div className="track-subtitle">{audioDetails.audioTitle}</div>
        </div>
      </div>

      <div className="progress-container">
        {/* Current Time */}
        <div className="time-current">{currentTime}</div>
        {/* Progress Bar */}
        <ProgressBar
          showThumb
          trackStyle={{
            height: '4px',
          }}
          min="0"
          max={rawTotalDuration}
          value={currentTimeInSeconds}
          onChange={handleSeek}
        />

        {/* Total Duration */}
        <div className="time-total">{totalDurations}</div>
      </div>

      <div className="volume-voice-control-container">
        {/* Playback Speed */}
        <div className="playback-container">
          <button className="playback-btn" onClick={() => setShowPlaybackMenu(!showPlaybackMenu)}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M10.45 15.5C10.85 15.9 11.3667 16.096 12 16.088C12.6333 16.08 13.1 15.8507 13.4 15.4L17.625 9.075C17.775 8.84167 17.7543 8.629 17.563 8.437C17.3717 8.245 17.159 8.22433 16.925 8.375L10.6 12.6C10.15 12.9 9.91267 13.3583 9.888 13.975C9.86333 14.5917 10.0507 15.1 10.45 15.5ZM12 4C12.6 4 13.1917 4.05 13.775 4.15C14.3583 4.25 14.925 4.40833 15.475 4.625C15.7417 4.725 16.025 4.91267 16.325 5.188C16.625 5.46333 16.7083 5.72567 16.575 5.975C16.4417 6.22433 16.1417 6.391 15.675 6.475C15.2083 6.559 14.8333 6.55067 14.55 6.45C14.1333 6.3 13.7127 6.18767 13.288 6.113C12.8633 6.03833 12.434 6.00067 12 6C9.78333 6 7.89567 6.77933 6.337 8.338C4.77833 9.89667 3.99933 11.784 4 14C4 14.7 4.096 15.3917 4.288 16.075C4.48 16.7583 4.75067 17.4 5.1 18H18.9C19.2833 17.3667 19.5627 16.7083 19.738 16.025C19.9133 15.3417 20.0007 14.6333 20 13.9C20 13.4667 19.9623 13.0417 19.887 12.625C19.8117 12.2083 19.6993 11.8 19.55 11.4C19.45 11.1167 19.4333 10.8417 19.5 10.575C19.5667 10.3083 19.7167 10.0833 19.95 9.9C20.1667 9.73333 20.4043 9.68333 20.663 9.75C20.9217 9.81667 21.1007 9.96667 21.2 10.2C21.45 10.7833 21.6417 11.3793 21.775 11.988C21.9083 12.5967 21.9833 13.2173 22 13.85C22.0167 14.8 21.9083 15.7083 21.675 16.575C21.4417 17.4417 21.1 18.2667 20.65 19.05C20.4667 19.35 20.2167 19.5833 19.9 19.75C19.5833 19.9167 19.25 20 18.9 20H5.1C4.75 20 4.41667 19.9167 4.1 19.75C3.78333 19.5833 3.53333 19.35 3.35 19.05C2.91667 18.3 2.58333 17.5043 2.35 16.663C2.11667 15.8217 2 14.934 2 14C2 12.6167 2.26267 11.321 2.788 10.113C3.31333 8.905 4.03 7.84667 4.938 6.938C5.846 6.02933 6.90833 5.31267 8.125 4.788C9.34167 4.26333 10.6333 4.00067 12 4Z"
                fill="#FECB04"
              />
            </svg>
            <span>{playbackSpeed}x</span>
          </button>
          {showPlaybackMenu && <SpeedSelector setShowPlaybackMenu={setShowPlaybackMenu} />}
        </div>
        {/* Volume Control */}
        <div className="volume-control">
          <button className="volume-btn" onClick={() => setShowVolumeSlider(!showVolumeSlider)} aria-label="Volume">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M19.07 4.93018C20.9447 6.80545 21.9979 9.34853 21.9979 12.0002C21.9979 14.6518 20.9447 17.1949 19.07 19.0702M15.54 8.46018C16.4774 9.39781 17.004 10.6694 17.004 11.9952C17.004 13.321 16.4774 14.5925 15.54 15.5302"
                stroke="#FECB04"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M11 5L6 9H2V15H6L11 19V5Z"
                fill="#FECB04"
                stroke="#FECB04"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>

          {showVolumeSlider && (
            <div className="volume-slider-popup" onMouseLeave={() => setShowVolumeSlider(false)}>
              <ProgressBar
                showThumb
                orientation="vertical"
                thumbStyle={{ height: '10px', width: '10px' }}
                trackStyle={{ width: '3px', height: '100px' }}
                min="0"
                max="1"
                value={volume}
                onChange={handleUpdateVolume}
              />
            </div>
          )}
        </div>

        {/* Voice Selector */}
        <div className="voice-selector">
          <button className="voice-btn" onClick={() => setIsVoiceDropdownOpen(!isVoiceDropdownOpen)}>
            <div className="voice-btn-content">
              <img src={currentVoice.flag} alt={currentVoice.name} className="voice-flag" />
              <span className="voice-name">{selectedVoice || 'Charlene'}</span>
            </div>
            <svg
              className={`chevron-icon ${isVoiceDropdownOpen ? 'open' : ''}`}
              width="14"
              height="8"
              viewBox="0 0 14 8"
              fill="none"
            >
              <path d="M1 1L7 7L13 1" stroke="#FECB04" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>

          {isVoiceDropdownOpen && (
            <div className="voice-dropdown-menu">
              {voices.map((voice, index) => (
                <div key={voice.name}>
                  {(index === 0 || voices[index - 1].category !== voice.category) && (
                    <div className="voice-category-label">{voice.category}</div>
                  )}
                  <button
                    className={`voice-option-item ${selectedVoice === voice.name ? 'active' : ''}`}
                    onClick={() => handleSelectVoice(voice.name)}
                  >
                    <img src={voice.flag} alt={voice.name} className="voice-option-flag" />
                    <span className="voice-option-name">{voice.name}</span>
                    <div className={`radio-circle ${selectedVoice === voice.name ? 'selected' : ''}`}>
                      {selectedVoice === voice.name && <div className="radio-inner" />}
                    </div>
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
      <button onClick={handleClose} className="close-btn">
        x
      </button>
    </div>
  );
}
